export const SET_QUALS = 'quals/SET_QUALS';
export const ADD_QUAL = 'quals/ADD_QUAL';
export const SET_SELECTED_QUAL = 'quals/SET_SELECTED_QUAL';
export const SET_ALL_SP = 'quals/SET_ALL_SP';
